import { FC } from 'react';
import { Typography } from '@mui/material';
import { ReactComponent as CheckSvg } from 'assets/icons/check-circle.svg';
import classNames from 'classnames';
import { ADVANTAGES_LIST } from './constants';
import styles from './index.module.scss';

interface HostCardAdvantagesListProps {
	className?: string;
}

export const HostCardAdvantagesList: FC<HostCardAdvantagesListProps> = ({ className = '' }) => {
	return (
		<ul className={classNames(styles.advantages__list, className)}>
			{ADVANTAGES_LIST.map((item) => (
				<li key={item}>
					<CheckSvg style={{ flexShrink: 0 }} />
					<Typography variant="caption" color="var(--color-primary-500)">
						{item}
					</Typography>
				</li>
			))}
		</ul>
	);
};
